'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formatAbstractDate = require('../internal/utils/formatAbstractDate');

var _formatAbstractDate2 = _interopRequireDefault(_formatAbstractDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value, type) {
  return (0, _formatAbstractDate2.default)({ value: value, type: type, format: 'MY', length: 's' });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/utils/formatShortMonthYear.js
// module id = 530
// module chunks = 177